export function apiResourcePath(resource) {
    return `/${resource}`;
}
